import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import FloatingActions from "@/components/landing/FloatingActions";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";
import { COMPANY } from "@/lib/company";

export default function AboutUs() {
  const scrollToForm = () => {
    window.location.href = "/#lead-form";
  };
  return (
    <div data-testid="about-page" className="min-h-screen bg-white text-neutral-900">
      <Header onCtaClick={scrollToForm} />

      <main className="pt-32 pb-20 lg:pt-40 lg:pb-28">
        <div className="max-w-4xl mx-auto px-6 lg:px-10">
          <p className="text-[11px] uppercase tracking-[0.25em] text-[#C5A059] font-semibold mb-3">
            About
          </p>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight mb-8 leading-[1.05]" data-testid="about-h1">
            About Fix Technical Renovation Company
          </h1>

          <div className="space-y-6 text-base lg:text-lg text-neutral-700 leading-relaxed">
            <p>
              Fix Technical Renovation Company is a Dubai-based renovation and interior fit-out contractor specializing in premium apartment renovation, villa renovation, kitchen remodeling, bathroom renovation, flooring, gypsum ceiling, painting, electrical works, plumbing works, custom joinery, and turnkey interior upgrades.
            </p>
            <p>
              We serve residential and commercial clients across Dubai with a focus on high-quality finishing, transparent communication, professional project supervision, and timely handover. Our team handles renovation work from concept to completion, including site inspection, quotation, planning, execution, finishing, and final handover.
            </p>
            <p>
              Whether the client is upgrading an apartment in Dubai Marina, remodeling a villa in Jumeirah, renovating a bathroom in Downtown Dubai, or improving a property in Business Bay, Fix Technical Renovation Company provides reliable renovation solutions with attention to detail and premium workmanship.
            </p>
          </div>

          <div className="mt-12 grid sm:grid-cols-2 gap-4">
            {[
              "European-Standard Craftsmanship",
              "Turn-key Project Management",
              "Transparent Quotation",
              "Authority Approval Coordination",
              "Premium Materials & Skilled Team",
              "Concept to Completion Execution",
            ].map((p) => (
              <div key={p} className="flex items-center gap-3 p-4 border border-neutral-200">
                <CheckCircle2 className="w-5 h-5 text-[#C5A059] flex-shrink-0" />
                <span className="text-sm font-medium text-neutral-800">{p}</span>
              </div>
            ))}
          </div>

          <div className="mt-12 bg-neutral-950 text-white p-8 lg:p-10">
            <p className="text-[11px] uppercase tracking-[0.25em] text-[#E2C988] font-semibold mb-2">
              Get in touch
            </p>
            <h2 className="font-heading text-2xl lg:text-3xl font-light mb-4">
              Request a Bespoke Consultation
            </h2>
            <p className="text-neutral-300 text-sm mb-6">
              Speak directly with a senior engineer from {COMPANY.name} to scope your renovation.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <a href={`tel:${COMPANY.phoneIntl}`}>
                <Button className="bg-[#C5A059] hover:bg-[#A88746] text-white rounded-none px-6 py-6 w-full">
                  Call {COMPANY.phone}
                </Button>
              </a>
              <a href={COMPANY.whatsappLink} target="_blank" rel="noopener noreferrer">
                <Button variant="outline" className="bg-transparent border-[#25D366] text-[#25D366] hover:bg-[#25D366] hover:text-white rounded-none px-6 py-6 w-full">
                  WhatsApp Renovation Expert
                </Button>
              </a>
            </div>
          </div>
        </div>
      </main>

      <Footer />
      <FloatingActions />
    </div>
  );
}
